export class Manager {
  constructor({
    id,
    vorname,
    nachname,
    ausgeblendeteArbeitsbereichIds,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    ausgeblendeteArbeitsbereichIds: string[];
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.ausgeblendeteArbeitsbereichIds = ausgeblendeteArbeitsbereichIds;
  }

  id: string;
  vorname: string;
  nachname: string;
  ausgeblendeteArbeitsbereichIds: string[];
}
